import { render, staticRenderFns } from "./region-proportion.vue?vue&type=template&id=06a7cf7b&scoped=true&"
import script from "./region-proportion.vue?vue&type=script&lang=js&"
export * from "./region-proportion.vue?vue&type=script&lang=js&"
import style0 from "./region-proportion.vue?vue&type=style&index=0&id=06a7cf7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a7cf7b",
  null
  
)

export default component.exports